import { useMemo } from 'react';
import { Country } from '@tiendanube/common/src/enums';
import { NUVEM_DOMAINS_TAG } from 'App/featuresFlags';
import { useHasTags } from 'App/hooks';
import { useResponsive } from 'commons/components';
import { useGetCountry } from 'domains/Auth/hooks';

const VALID_COUNTRIES_FOR_NUVEM_DOMAINS = [Country.MX, Country.AR];

export function useHasNuvemDomainEnabled() {
  const country = useGetCountry();
  const [hasNuvemDomainsTag] = useHasTags(NUVEM_DOMAINS_TAG);
  const { isDesktop } = useResponsive();

  const isEnabled = useMemo(() => {
    const isCountryValid = VALID_COUNTRIES_FOR_NUVEM_DOMAINS.includes(country);
    return hasNuvemDomainsTag && isCountryValid && isDesktop;
  }, [hasNuvemDomainsTag, country, isDesktop]);

  return isEnabled;
}
